export default __webpack_public_path__ + "static/colorview-df3227a4734af71a87cfe5150e523126.jpg";